export enum PhoneVerificationStatus {
  unverified = 'unverified',
  waiting = 'waiting',
  verified = 'verified',
}
